import {alertActionTypes as types} from 'actions/actionTypes';

const initialState = {
  errors: [],
  successes: [],
  warnings: [],
};

export default function alerts(state = initialState, action) {
  switch (action.type) {
    case types.CLEAR_ERROR:
      return {...state, errors: []};
    case types.ERROR_MSG:
      return {...state, errors: [...state.errors, action.message]};
    case types.CLEAR_SUCCESS:
      return {...state, successes: []};
    case types.SUCCESS_MSG:
      return {...state, successes: [...state.successes, action.message]};
    case types.CLEAR_WARNING:
      return {...state, warnings: []};
    case types.WARNING_MSG:
      return {...state, warnings: [...state.warnings, action.message]};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alertsReducer.js